<template>
    <div class="Statistics" >
        <Title firstName="暖通系统设备启停统计" lastName="EQUIPMENT START AND STOP"/>
        <div class="echarts">
           <div class="floor">
               <div class="item" v-for="item in deviceList" :key="item.id">
                   <div class="title">{{item.title}}</div>
                   <div class="progress">
                       <div class="num">{{item.num}}<span>/{{item.all}}</span></div>
                       <div class="state">启动/停止</div>
                   </div>
                   <div class="error">故障：{{item.bad}}</div>
               </div>
           </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')
const charts = () => import('../../../../components/echarts/charts.vue')
export default {
    data(){
        return {
            deviceList:[
                {
                    id:1,
                    title:"暖通设备",
                    num:'--',
                    all:'200',
                    bad:'0'
                },
                {
                    id:2,
                    title:"照明设备",
                    num:'--',
                    all:'4695',
                    bad:'0'
                },
                {
                    id:3,
                    title:"安防设备",
                    num:'--',
                    all:'129',
                    bad:'0'
                }
            ]
        }
    },
    components:{
        Title,charts
    },
    mounted(){
        
    },
    methods:{
       
    },
    watch:{
        
    },
    computed:{
        
    }
}
</script>

<style lang="less" scoped>
    .Statistics{
        // height: 33.3vh;
        width: 20vw;
        // height: 493rem;
        position: fixed;
        top: 7.4vh;
        left: 2vw;
        z-index: 1;

        .echarts{
            position: relative;
            height: 18vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            overflow: hidden;
            .floor{
                padding:1vh 30rem 0;
                display: flex;
                align-items: center; 
                justify-content: space-between;
                .item{
                    overflow: hidden;
                    color: rgba(230, 243, 253, 0.7);
                    font-size: 15rem;
                    margin:1vh 0;
                    text-align: center;
                    .title{
                        margin-bottom: 5rem;
                    }
                    .progress{
                        background: url('../../../../assets/img/bottom.png');
                        width:88rem;
                        height: 88rem;
                        background-size: 100% 100%;
                        margin: 10rem 0;
                        display: flex;
                        flex-flow: row wrap;
                        align-items: center;
                        padding: 17rem 0;
                        font-size: 14rem;
                        .num{
                            color: #00DEFF;
                            font-size: 22rem;
                            width: 100%;
                            font-family: zcoolqingkehuangyouti;
                            span{
                                font-size: 16rem;
                                font-family: zcoolqingkehuangyouti;
                            }
                        }
                        .state{
                            text-align: center;
                            width: 100%;
                        }
                    }
                }
            }
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
</style>